import React from 'react';
import styles from './ORSMActivationConfirmation.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';

interface Props {
	onClose: () => void;
}

const ORSMActivationConfirmation: React.FC<Props> = ({ onClose }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.circle1}>
				<div className={styles.circle2}>
					<img
						src='/dist/icons/subscription/circle-check-solid-full-green.svg'
						alt='green check'
					/>
				</div>
			</div>
			<Text
				tx='component.ORSMActivationConfirmation.message'
				className={styles.title}
			/>
			<Text tx='component.ORSMActivationConfirmation.text' />
			<Button
				theme={Theme.BLUE}
				title='component.ORSMActivationConfirmation.goToAdmin'
				className={styles.button}
				onClick={onClose}
			/>
			<LinkButton
				title='base.shared.close'
				theme={Theme.BLUE}
				onClick={onClose}
			/>
		</div>
	);
};

export default ORSMActivationConfirmation;
